import React, { useContext, useEffect } from 'react';
import styles from './AccountOwnerDetail.style';
import { AppContext } from 'App.context';
import AppTextInput from 'Components/common/AppTextInput/AppTextInput';
import PhoneInput from 'react-phone-input-2';
import Space from 'Components/common/Space/Space';
import useAccountOwnerDetailHook from './AccountOwnerDetail.hook';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import storage from '../../../../utils/storage';
import { Col, Row, Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function AccountOwnerDetail({ userId }) {
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useAccountOwnerDetailHook();
  const isOwnerOrSuperUser = appState.userId === appState.ownerId || appState.superUser === true;
  const isSuperUser = appState.superUser === true;
  const chainData = storage.get('slug');
  const chainName = JSON.parse(chainData)?.name || '';

  useEffect(() => {
    if (chainName && state.chainName !== chainName) {
      actions.setField('chainName', chainName);
    }
  }, [chainName]);

  return (
    <div>
      {chainName && (
        <>
          <AppTextInput
            value={state.chainName}
            name={translate('register.chain')}
            onChange={value => actions.setField('chainName', value)}
          />
        </>
      )}
      <AppTextInput
        value={state.name}
        name={translate('register.name')}
        onChange={value => actions.setField('name', value)}
        disabled={!isOwnerOrSuperUser}
      />
      <Space height={8} />
      <AppTextInput
        value={state.email}
        name={translate('register.mail')}
        onChange={value => actions.setField('email', value)}
        disabled
      />
      <Space height={8} />
      <div style={styles.inputTitle}>{translate('register.phone')}</div>
      <PhoneInput
        inputStyle={styles.input}
        buttonStyle={styles.button}
        country={'es'}
        value={state.phone}
        placeholder={translate('register.phone')}
        onChange={phone => actions.setField('phone', phone)}
        disabled={!isOwnerOrSuperUser}
      />

      <Modal
        open={state.isDeleteModalVisible}
        onCancel={actions.closeDeleteUserModal}
        footer={null}
        width={521}
        height={391}
      >
        <div style={styles.textContainerModal}>
          <div style={styles.iconModal}>
            <ExclamationCircleOutlined />
          </div>
          <div style={styles.titleModal}>
            <strong>{translate('team.usersDetail.deleteConfirmTitle')}</strong>
          </div>
          <div style={styles.textModal}>
            <p>{translate('accountOwner.deleteConfirmDescription')}</p>
          </div>
        </div>
        <div style={styles.modalButton}>
          <Button
            key="delete"
            type="primary"
            danger
            onClick={async () => {
              const twoFAResult = await show2FAModal();

              if (twoFAResult === true) {
                actions.removeAccount(userId);
              }
            }}
            style={styles.deleteButton}
          >
            {translate('team.usersDetail.delete')}
          </Button>
        </div>
        <div style={styles.modalButton}>
          <Button key="cancel" onClick={actions.closeDeleteUserModal} style={styles.cancelButton}>
            {translate('team.usersDetail.cancel')}
          </Button>
        </div>
      </Modal>

      <Row justify="center">
        {isSuperUser && (
          <Col span={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <AppButton
              style={styles.deleteButton}
              text={translate('deleteAccount')}
              action={() => actions.openDeleteUserModal(userId)}
            />
          </Col>
        )}
        {isOwnerOrSuperUser && (
          <Col span={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <AppButton
              style={styles.buttonStyle}
              text={translate('save')}
              action={() => actions.validateFormAndUpdateUser()}
            />
          </Col>
        )}
      </Row>
    </div>
  );
}
